module.exports = __webpack_public_path__ + "img/Wix_Add_Code.e25570c6.jpg";